import { z } from 'zod'

export const responseSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  dataSchema
